// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconUserUserUserGroup_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M14 4.5C14 6.433 12.433 8 10.5 8 8.567 8 7 6.433 7 4.5 7 2.567 8.567 1 10.5 1 12.433 1 14 2.567 14 4.5ZM12 4.5C12 5.32843 11.3284 6 10.5 6 9.67157 6 9 5.32843 9 4.5 9 3.67157 9.67157 3 10.5 3 11.3284 3 12 3.67157 12 4.5ZM7 7C7 8.65685 5.65685 10 4 10 2.34315 10 1 8.65685 1 7 1 5.34315 2.34315 4 4 4 5.65685 4 7 5.34315 7 7ZM5 7C5 7.55228 4.55228 8 4 8 3.44772 8 3 7.55228 3 7 3 6.44772 3.44772 6 4 6 4.55228 6 5 6.44772 5 7Z" class="svg-bg"/>
  <path d="M14 15V14.5C14 12.567 12.433 11 10.5 11C8.567 11 7 12.567 7 14.5V15H5V14.5C5 14.1034 5.04197 13.7167 5.12171 13.3439C4.80182 13.1268 4.41572 13 4 13C2.89543 13 2 13.8954 2 15H0C0 12.7909 1.79086 11 4 11C4.68859 11 5.33654 11.174 5.90229 11.4804C6.88557 9.98627 8.57761 9 10.5 9C13.5376 9 16 11.4624 16 14.5V15H14Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M21 7C21 9.76142 18.7614 12 16 12 13.2386 12 11 9.76142 11 7 11 4.23858 13.2386 2 16 2 18.7614 2 21 4.23858 21 7ZM19 7C19 8.65685 17.6569 10 16 10 14.3431 10 13 8.65685 13 7 13 5.34315 14.3431 4 16 4 17.6569 4 19 5.34315 19 7ZM10 11C10 13.2091 8.20914 15 6 15 3.79086 15 2 13.2091 2 11 2 8.79086 3.79086 7 6 7 8.20914 7 10 8.79086 10 11ZM8 11C8 12.1046 7.10457 13 6 13 4.89543 13 4 12.1046 4 11 4 9.89543 4.89543 9 6 9 7.10457 9 8 9.89543 8 11Z" class="svg-bg"/>
  <path d="M22 22H24C24 17.5817 20.4183 14 16 14C13.3829 14 11.0594 15.2566 9.59984 17.1994C8.59707 16.4463 7.35065 16 6 16C2.68629 16 0 18.6863 0 22H2C2 19.7909 3.79086 18 6 18C6.99184 18 7.89936 18.361 8.59835 18.9588C8.21269 19.8963 8 20.9233 8 22H10C10 18.6863 12.6863 16 16 16C19.3137 16 22 18.6863 22 22Z" class="svg-bg"/>
</svg>
`;
/**
 * IconUserUserUserGroup is a generated icon component.
 */
let IconUserUserUserGroup = IconUserUserUserGroup_1 = class IconUserUserUserGroup extends IconBaseElement {
    render() {
        return html `${IconUserUserUserGroup_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconUserUserUserGroup.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconUserUserUserGroup = IconUserUserUserGroup_1 = __decorate([
    customElement('zui-icon-user-user-user-group')
], IconUserUserUserGroup);
export { IconUserUserUserGroup };
